import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { ReactNode } from 'react';
import React, { useState, useEffect } from 'react';

import { INTRFAddress } from '../../hooks/Interfaces';

interface AddressBlockProps {
    formPrefix: string;
    address: INTRFAddress;
    updateAddress: (address: INTRFAddress) => void;
    /*outputadd1: (address1: string) => void;
    outputadd2: (address2: string) => void;
    outputcity: (city: string) => void;
    outputstate: (state: string) => void;
    outputpostal: (postal: string) => void;*/
}


function AddressBlock({formPrefix, address, updateAddress}: AddressBlockProps){
    let [addr, setAddress] = useState(address);
    let [address1, setAddress1] = useState(address.address1);
    let [address2, setAddress2] = useState(address.address2);
    let [city, setCity] = useState(address.city);
    let [state, setState] = useState(address.state);
    let [zip, setZip] = useState(address.zip);

    /* Component Init */
    useEffect(() => {
        setAddress({
            address1: address1,
            address2: address2,
            city: city,
            state: state,
            zip: zip,
        });
        updateAddress({
            address1: address1,
            address2: address2,
            city: city,
            state: state,
            zip: zip,
        })
        
    }, [address1,address2,city,state,zip]);

    return (
        <> 
            <Row>
                <Col>
                    <div className="brand-tertiary-color-border">
                        <input placeholder="Address (Line 1) *" type="text" className="border-0 input-fill no-generic-input-styles" id={formPrefix + "_address1"} value={addr.address1} aria-describedby="textHelp" onChange={(e) => setAddress1(e.target.value)} />
                    </div>
                    
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="brand-tertiary-color-border">
                        <input placeholder="Address (Line 2) " type="text" className="border-0 input-fill no-generic-input-styles" id={formPrefix + "_address2"} value={addr.address2} aria-describedby="textHelp" onChange={(e) => setAddress2(e.target.value)}/>
                    </div>
                    
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="brand-tertiary-color-border">
                        <input placeholder="City *" type="text" className="border-0 input-fill no-generic-input-styles" id={formPrefix + "_city"} value={addr.city} aria-describedby="textHelp" onChange={(e) => setCity(e.target.value)} />
                    </div>
                    
                </Col>
                <Col>
                    <div className="brand-tertiary-color-border">
                        <input placeholder="State *" type="text" className="border-0 input-fill no-generic-input-styles" id={formPrefix + "_state"} value={addr.state} aria-describedby="textHelp" onChange={(e) => setState(e.target.value)} />
                    </div>
                    
                </Col>
                <Col>
                    <div className="brand-tertiary-color-border">
                        <input placeholder="Postal / Zip Code *" type="text" className="border-0 input-fill no-generic-input-styles" id={formPrefix + "_postal"} value={addr.zip} aria-describedby="textHelp" onChange={(e) => setZip(e.target.value)}/>
                    </div>
                    
                </Col>
            </Row>
        </>
    )
}

export default AddressBlock;